


















































































import { Vue, Component } from "@/shared/vuepack";
import * as umb from "@/shared/umbUrls";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {
  }
})
export default class UmbForms extends Vue {
  UmbUrls = umb;

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
